/*! B6-7 optional (theme half): mobile menu a11y helpers on top of live header + blazin.js.
   - Does NOT bind #mobile-menu-toggle click (blazin.js adds .open; live header inline uses .is-open).
   - MutationObserver syncs aria-expanded / aria-hidden from .open or .is-open.
   - Escape and #mobile-nav-overlay click close both class systems; focus returns to toggle.
   Link order is untouched (hardcoded in sections/header.liquid). */
(function () {
  "use strict";
  var toggle = document.getElementById("mobile-menu-toggle");
  var nav = document.getElementById("mobile-nav");
  var overlay = document.getElementById("mobile-nav-overlay");
  if (!toggle || !nav) return;

  function menuOpen() {
    return nav.classList.contains("open") || nav.classList.contains("is-open");
  }

  function cartOpen() {
    var cart = document.getElementById("cart-drawer");
    return (
      document.body.classList.contains("bz-cart-open") ||
      (cart && cart.classList.contains("open"))
    );
  }

  function syncAria() {
    var open = menuOpen();
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    nav.setAttribute("aria-hidden", open ? "false" : "true");
  }

  function focusToggle() {
    try {
      toggle.focus({ preventScroll: true });
    } catch (e) {
      try {
        toggle.focus();
      } catch (e2) {}
    }
  }

  function closeMenu() {
    var wasOpen = menuOpen();
    nav.classList.remove("open", "is-open");
    if (overlay) overlay.classList.remove("is-open", "open");
    if (!cartOpen()) document.body.style.overflow = "";
    syncAria();
    if (wasOpen) focusToggle();
  }

  var prevOpen = menuOpen();
  syncAria();

  var mo = new MutationObserver(function () {
    var open = menuOpen();
    syncAria();
    if (prevOpen && !open) focusToggle();
    prevOpen = open;
  });
  mo.observe(nav, { attributes: true, attributeFilter: ["class"] });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (cartOpen()) return;
    if (!menuOpen()) return;
    e.preventDefault();
    closeMenu();
  });

  if (overlay) {
    overlay.addEventListener("click", function () {
      if (menuOpen()) closeMenu();
    });
  }
})();